import {Component, OnInit} from '@angular/core';
import {
    NavigationTableRequestModel,
    NavigationTableResponseItemModel,
    NavigationTableResponseModel
} from '../../../models/file-table.model';
import {DocumentsServiceService} from '../documents-service.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentsApiService} from '../../../services/api/documents-api.service';
import {saveAs} from 'file-saver';
import {AlertService} from '../../../services/notify/alert.service';
import {ModalService} from '../../../services/modal/modal.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-document-list',
    templateUrl: './document-list.component.html',
    styleUrls: ['./document-list.component.scss'],
})
export class DocumentListComponent implements OnInit {
    public response: NavigationTableResponseModel;
    public tableType = 'all';
    public isCreateCollection = false;
    public isCreateFolder = false;
    isLoadingZip = false;
    isLockDeleteButton = false;

    pagination: NavigationTableRequestModel;

    tab: 'view' | 'edit' | 'access' = 'view';
    showTabs = false;
    isPermissionsChanged = false;

    constructor(
        public controller: DocumentsServiceService,
        public docAPI: DocumentsApiService,
        protected activeRoute: ActivatedRoute,
        protected router: Router,
        protected alertService: AlertService,
        private modalService: ModalService,
        public translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.activeRoute.params.subscribe(params => {
            this.isCreateCollection = this.isCreateFolder = false;
            const obj = {
                id: 0,
                filter: params.filter ? params.filter : 'all',
                limit: 50,
                current_page: 1,
            };
            if (obj.filter === 'all') {
                obj.id = params.folder ? params.folder : 0;
            } else if (obj.filter === 'collection') {
                obj.id = params.collection ? params.collection : 0;
            }

            this.tableType = obj.filter;

            this.onEventFind(obj);
        });

        this.controller.$mediator.subscribe((response: NavigationTableResponseModel) => {
            this.response = response;
            this.isCreateFolder = response.right ? response.right.is_create_folder : true;
            if (response.folder) {
                this.isCreateCollection = response.right.is_upload_file;
            }
            this.showTabs = !!response.folder && !!['folder', 'collection'].includes(response.folder.type_str);
        });
    }

    getZipFile(): void {
        if (this.isLoadingZip) {
            return;
        }
        this.isLoadingZip = true;
        const req = this.docAPI.getZipCollection(this.controller.request.id);
        const currentName = this.response.folder.name.split('.')[0] + '.zip';

        req.subscribe((data: BlobPart) => {
            const file = new Blob([data as BlobPart]);
            saveAs(file, currentName);
            this.isLoadingZip = false;
        });
    }

    onEventFind(request: any = null): void {
        this.pagination = this.controller.prepare(request);
        this.controller.loadNav(this.pagination);
    }

    async onEventTrClick(item: NavigationTableResponseItemModel = null): Promise<any> {
        // /account/doc/file
        const com = ['account', 'doc'];
        if (item) {
            if (item.type_str === 'file') {
                com.push('nav', 'file', item.key);
            } else if (item.type_str === 'collection') {
                com.push('nav', 'collection', item.id.toString());
            } else if (item.type_str === 'folder') {
                com.push('nav', item.id.toString());
            } else if (!item.type_str) {
                com.push('nav');
            } else {
                throw new Error('Invalid item.type');
            }
        } else {
            com.push('nav');
        }
        await this.router.navigate(com);
    }

    deleteCollection(collection: NavigationTableResponseModel): void {
        if (this.isLockDeleteButton) {
            return;
        }
        const modalSettings = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_COLLECTION'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.isLockDeleteButton = true;
                this.docAPI.deleteCollection(collection.folder.id).subscribe({
                    next: res => {
                        this.alertService.setAlert(res.message, 'green');
                        if (collection.data.length === 1 || !collection.data.length) {
                            void this.router.navigate(['account', 'doc', 'nav', collection.parent.id]);
                        } else {
                            this.controller.loadNav();
                        }
                        this.isLockDeleteButton = false;
                    },
                    error: error => {
                        this.alertService.setAlert(error.message, 'blue');
                        this.isLockDeleteButton = false;
                    },
                });
            }
        }).catch(() => {
            return;
        });
    }

    onEditFolder(nameFolder: string, description: string): void {
        if (!this.response.folder.name) {
            this.alertService.setAlert(this.translate.instant('ALERTS.CREATE_FOLDER_NAME'), 'blue');
        }
        const data = {
            id: this.response.folder.id,
            name: nameFolder,
            pid: this.response.folder.pid,
            folder_description: description,
        };

        this.docAPI.editFolder(data).subscribe({
            next: res => {
                this.alertService.setAlert(res.message, 'green');
                this.controller.loadNav();
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }
}
